/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_Overpay_NoteInputs */

const vi_order_payment_method_change_overpay_note = /** @type {(inputs: Order_Payment_Method_Change_Overpay_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu khách đưa dư và phần dư được tính vào công nợ thì phiếu thu phần dư cũng đổi theo.`)
};

/**

* @param {Order_Payment_Method_Change_Overpay_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_overpay_note = /** @type {((inputs?: Order_Payment_Method_Change_Overpay_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_Overpay_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_overpay_note(inputs)
});